import { render, staticRenderFns } from "./country-multiselect.vue?vue&type=template&id=3673a3af"
import script from "./country-multiselect.vue?vue&type=script&lang=ts"
export * from "./country-multiselect.vue?vue&type=script&lang=ts"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports